<template>
    <Dialog v-model:visible="localVisible" modal :header="header" :style="{ width: dialogWidth, paddingLeft: '20px' }"
        @hide="handleClose" :maximizable="isMaximizable" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
        <slot name="dialogContent"></slot>
    </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog';

export default {
    name: 'DialogBox',
    components: {
        Dialog
    },
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        header: {
            type: String,
            required: true
        },
        isMaximizable: {
            type: Boolean,
            default: false,
        },
        dialogWidth: {
            type: String,
            default: '50rem',
        }
    },
    data() {
        return {
            localVisible: this.visible
        }
    },
    watch: {
        visible(val) {
            this.localVisible = val
        }
    },
    methods: {
        handleClose() {
            this.localVisible = false;
            this.$emit('handleClose', false)
        }
    }
}
</script>

<style lang="scss">
/* add your styles here */
</style>

